import React, { useState, useEffect } from "react";
import { Alert, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PageInstructions = ({ children, storageKey = "pageInstructions" }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(storageKey);
    if (dismissed === "true") {
      setOpen(false);
    }
  }, [storageKey]);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(storageKey, "true");
  };

  return (
    <Collapse in={open}>
      <Alert
        severity="info"
        sx={{ mb: 2, alignItems: "flex-start", backgroundColor: "#90b5fe" }}
        action={
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {/* ✅ THIS IS THE MISSING PART */}
        {children}
      </Alert>
    </Collapse>
  );
};
export default PageInstructions;